import type { ReactNode } from 'react'

import { ConsoleViewContext, type ConsoleViewState } from './state'

export function ConsoleSnapshotProvider({
  snapshot,
  connectionStatus,
  children,
}: ConsoleViewState & { children: ReactNode }) {
  return (
    <ConsoleViewContext.Provider value={{ snapshot, connectionStatus }}>
      {children}
    </ConsoleViewContext.Provider>
  )
}
